/**
 * Desktop (Electron) eligibility mirrors Google Apps Script license policy.
 */

export function licensePolicyAllowsDesktop(lic) {
  if (!lic) return false;
  const plan = String(lic.plan || '').toLowerCase().trim();
  if (plan === 'ultimate' || plan === 'lifetime') return true;
  if (plan.includes('lifetime')) return true;
  const il = lic.isLifetime ?? lic.is_lifetime;
  if (il === true || il === 'TRUE' || il === 'true' || il === 1) return true;
  return false;
}

export function licenseIsCurrentlyValidForActivation(lic) {
  if (!lic) return false;
  if (lic.isActive === false || lic.isActive === 'FALSE' || lic.isActive === 'false') return false;
  const il = lic.isLifetime ?? lic.is_lifetime;
  if (il === true || il === 'TRUE' || il === 'true') return true;
  const plan = String(lic.plan || '').toLowerCase();
  if (plan.includes('lifetime')) return true;
  const ed = lic.expiryDate || lic.expiry_date;
  if (!ed || String(ed).trim() === '') return true;
  const exp = new Date(ed);
  if (Number.isNaN(exp.getTime())) return true;
  return new Date() <= exp;
}

/** Prefer server-computed allowsDesktop when present; else derive from plan / lifetime. */
export function licenseAllowsDesktopUse(lic) {
  if (!lic) return false;
  if (typeof lic.allowsDesktop === 'boolean') return lic.allowsDesktop;
  return licensePolicyAllowsDesktop(lic);
}

export function isDesktopElectronBuild() {
  return typeof window !== 'undefined' && !!window.electronAPI;
}
